import EventEmitter from 'wolfy87-eventemitter';

const tinyPubSub = new EventEmitter();

export function subscribe(...args) {
  tinyPubSub.addListener(...args);
}

export function unsubscribe(event, callback) {
  if (callback) {
    tinyPubSub.removeListener(event, callback);
  } else {
    tinyPubSub.removeEvent(event);
  }
}

export function publish(...args) {
  tinyPubSub.emitEvent(...args);
}
